module.exports = __webpack_public_path__ + "static/media/solutions-1040scan.df99c091.svg";